"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _enums = require("MeetingsLib/constants/enums");

var _color = require("MeetingsBase/utils/color");

var _color2 = require("MeetingsLib/utils/color");

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _default = (0, _createReactClass.default)({
  displayName: "TimePickerButton",
  propTypes: {
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    disabled: _propTypes.default.bool,
    handleSetEventDateTime: _propTypes.default.func.isRequired,
    conflictingEvent: _propTypes.default.shape({
      email: _propTypes.default.string,
      firstName: _propTypes.default.string,
      lastName: _propTypes.default.string,
      relatedEventStartTimeMillis: _propTypes.default.number
    }),
    selectedTime: _propTypes.default.number,
    time: _propTypes.default.number.isRequired,
    unavailableReason: _propTypes.default.string,
    userTimezone: _propTypes.default.string.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      hover: false
    };
  },
  onMouseEnter: function onMouseEnter() {
    this.setState({
      hover: true
    });
  },
  onMouseLeave: function onMouseLeave() {
    this.setState({
      hover: false
    });
  },
  getBrandingActiveStyle: function getBrandingActiveStyle() {
    var _this$props = this.props,
        primaryColor = _this$props.branding.primaryColor,
        time = _this$props.time,
        selectedTime = _this$props.selectedTime;
    var hover = this.state.hover;

    if (!hover && time !== selectedTime) {
      return null;
    }

    return {
      borderColor: primaryColor,
      backgroundColor: (0, _color2.getColorStyleWithOpacity)(primaryColor)
    };
  },
  getBrandingTextStyle: function getBrandingTextStyle() {
    var primaryColor = this.props.branding.primaryColor;

    if (!primaryColor) {
      return null;
    }

    return {
      color: (0, _color.getPrimaryColorOrDefault)(primaryColor)
    };
  },
  getOwnerName: function getOwnerName() {
    var _this$props$conflicti = this.props.conflictingEvent,
        firstName = _this$props$conflicti.firstName,
        lastName = _this$props$conflicti.lastName,
        email = _this$props$conflicti.email;
    var formattedName = (0, _formatName.default)({
      firstName: firstName,
      lastName: lastName
    });
    return formattedName || email;
  },
  getUnavailableMessageProps: function getUnavailableMessageProps() {
    var _this$props2 = this.props,
        unavailableReason = _this$props2.unavailableReason,
        relatedEventStartTimeMillis = _this$props2.conflictingEvent.relatedEventStartTimeMillis;
    var ownerName = this.getOwnerName();

    switch (unavailableReason) {
      case _enums.UNAVAILABLE_REASONS.PAST:
        return {
          message: 'troubleshoot.past'
        };

      case _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT:
        return {
          message: 'troubleshoot.allDayBusy',
          options: {
            ownerName: ownerName
          }
        };

      case _enums.UNAVAILABLE_REASONS.EVENT:
        return {
          message: 'troubleshoot.busy',
          options: {
            ownerName: ownerName
          }
        };

      case _enums.UNAVAILABLE_REASONS.BUFFER:
        return {
          message: 'troubleshoot.buffer',
          options: {
            relatedEventStartTime: this.getLowercaseTime(relatedEventStartTimeMillis)
          }
        };

      case _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE:
        return {
          message: 'troubleshoot.minimumNotice'
        };

      default:
        return {
          message: 'troubleshoot.default'
        };
    }
  },
  getLowercaseTime: function getLowercaseTime(timestamp) {
    var userTimezone = this.props.userTimezone;

    var timeOfDay = _I18n.default.moment(timestamp).tz(userTimezone).format('LT');

    return timeOfDay.toLowerCase();
  },
  renderUnavailableReason: function renderUnavailableReason() {
    var disabled = this.props.disabled;

    if (!disabled) {
      return null;
    }

    var text = _react.default.createElement(_FormattedReactMessage.default, this.getUnavailableMessageProps());

    return _react.default.createElement(_UITruncateString.default, {
      tooltip: _react.default.createElement(_Small.default, null, text)
    }, _react.default.createElement(_Small.default, {
      use: "help"
    }, text));
  },
  renderMinutes: function renderMinutes() {
    var time = this.props.time;
    var lowerCaseTimeOfDay = this.getLowercaseTime(time);
    return _react.default.createElement("span", {
      style: this.getBrandingTextStyle()
    }, lowerCaseTimeOfDay);
  },
  render: function render() {
    var _this$props3 = this.props,
        disabled = _this$props3.disabled,
        handleSetEventDateTime = _this$props3.handleSetEventDateTime,
        selectedTime = _this$props3.selectedTime,
        time = _this$props3.time;
    return _react.default.createElement("div", {
      className: "p-y-1 p-right-1"
    }, _react.default.createElement(_UISelectableBox.default, {
      disabled: disabled,
      block: true,
      padded: false,
      className: "time-picker-btn",
      selected: selectedTime === time,
      style: this.getBrandingActiveStyle(),
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: handleSetEventDateTime
    }, this.renderMinutes(), _react.default.createElement("br", null), this.renderUnavailableReason()));
  }
});

exports.default = _default;
module.exports = exports.default;